import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ExactTimeIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C12.225 22 12.445 21.9818 12.666 21.9668C12.378 21.3528 12.1781 20.6911 12.0781 19.9961H12.0723C12.0253 19.6711 12 19.339 12 19C12 15.134 15.134 12 19 12C19.339 12 19.6711 12.0262 19.9961 12.0742V12.0781C20.6911 12.1771 21.3538 12.379 21.9668 12.668C21.9818 12.446 22 12.225 22 12C22 6.486 17.514 2 12 2ZM11.9902 6H12.0098C12.5568 6 13 6.44323 13 6.99023V12.0039C13 12.2669 12.8969 12.5171 12.7109 12.7031L9.40625 16.0078C9.01925 16.3948 8.39481 16.3948 8.00781 16.0078L7.99219 15.9922C7.60519 15.6052 7.60519 14.9808 7.99219 14.5938L11 11.5859V6.99023C11 6.44323 11.4432 6 11.9902 6ZM19 14C16.239 14 14 16.239 14 19C14 21.761 16.239 24 19 24C21.761 24 24 21.761 24 19C24 16.239 21.761 14 19 14ZM21.0508 17.0605C21.304 17.0605 21.5565 17.1561 21.75 17.3496C22.137 17.7366 22.137 18.363 21.75 18.75L19.1992 21.3008C18.8122 21.6878 18.1878 21.6878 17.8008 21.3008L16.25 19.75C15.863 19.363 15.863 18.7366 16.25 18.3496C16.637 17.9626 17.2634 17.9626 17.6504 18.3496L18.5 19.1992L20.3496 17.3496C20.5431 17.1561 20.7975 17.0605 21.0508 17.0605Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ExactTimeIcon.propTypes = {
  sx: PropTypes.object,
};

export default ExactTimeIcon;
